<template>
    <div ref="modal" class="modal fade" id="createOfferModal" tabindex="-1" role="dialog"
         aria-labelledby="exampleModalLabel"
         aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                        {{ __('actions.create_thing', {thing: __('general.offer')}) }}
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i aria-hidden="true" class="ki ki-close"/>
                    </button>
                </div>
                <div class="modal-body d-flex justify-content-center">
                    <div class="w-75">
                        <FormGroupNew :label="__('offers.name')"
                                      :description="__('offers.specify_name')"
                                      :error="newOffer.errors.name"
                                      required>
                            <input class="form-control" type="text" v-model="newOffer.name">
                        </FormGroupNew>

                        <FormGroupNew :label="__('actions.select_thing', {thing: __('general.stores')})"
                                      :error="newOffer.errors.store_uuids"
                                      required>
                            <div v-for="store in stores" :key="store.id">
                                <label>
                                    <input type="checkbox"
                                           @change="updateSelectedStores(store.id, $event.target.checked)">
                                    <span>{{ store.attributes.name }}</span>
                                    <StoreAddress class="text-muted d-block pl-5" :store="store"/>
                                </label>
                            </div>
                        </FormGroupNew>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary font-weight-bold" @click="createOffer">
                        {{ __('actions.create') }}
                    </button>
                    <button type="button" class="btn btn-light-primary font-weight-bold" data-dismiss="modal">
                        {{ __('actions.abort') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Errors from '@components/Errors'
import StoreAddress from '@components/Store/StoreAddress.vue'
import Checkbox from "@components/Form/Checkbox.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";

export default {
    components: {
        FormGroupNew,
        Checkbox,
        StoreAddress,
        Errors,
    },

    props: {
        stores: Array,
    },

    data() {
        return {
            newOffer: this.$inertia.form({
                name: null,
                store_uuids: []
            })
        }
    },

    methods: {
        updateSelectedStores(storeUuid, isSelected) {
            if (isSelected) {
                this.newOffer.store_uuids.pushUnique(storeUuid);
            } else {
                this.newOffer.store_uuids.removeElement(storeUuid);
            }
        },

        createOffer() {
            this.newOffer.put(this.$route('offers.create'));
        },
    },
}
</script>
